import { RootState } from 'reducers';
import { OptionProps } from 'react-apollo';
import {
  OrderSubmitParamsQuery,
  OrderSubmitParamsQueryVariables,
  OrderSubmitParamsQuery_lab_idea as Idea,
} from './__generated__/OrderSubmitParamsQuery';
import { Props } from './index';

export const selector = (state: RootState) => state.components.orderSubmitModal;

export type Selector = ReturnType<typeof selector>;

export {
  OrderSubmitParamsQuery,
  OrderSubmitParamsQueryVariables,
} from './__generated__/OrderSubmitParamsQuery';

export interface Data {
  min: number;
  max: number;
  initialAmount: number;
  idea?: Idea;
}

export const responseToProps = ({
  data,
}: OptionProps<
  Props & Selector,
  OrderSubmitParamsQuery,
  OrderSubmitParamsQueryVariables
>): Data => {
  if (!data || !data.billing || !data.billing.mainAccounts || !data.lab || !data.lab.idea) {
    return { min: 0, max: 0, initialAmount: 0 };
  }

  const { idea } = data.lab;

  const result = data.billing.mainAccounts.find(
    ({ balance }) => balance.currency === idea.enterAmount.currency
  );

  const balance = result ? result.balance.value : 0;

  const maxEnterAmount =
    idea.properties.__typename === 'Investment_BuyAndHoldIdeaProperties' &&
    idea.properties.maxEnterAmount
      ? idea.properties.maxEnterAmount.value
      : Number.MAX_VALUE;

  const min = idea.enterAmount.value;

  const max = Math.min(balance, maxEnterAmount);

  return {
    idea,
    min,
    max,
    initialAmount: min,
  };
};
